/**
 * Utilitário consolidado para requisições autenticadas
 * Substitui as múltiplas implementações duplicadas de authenticatedFetch
 */

const API_BASE_URL = '';

/**
 * Faz uma requisição HTTP autenticada com o token JWT
 * @param url - URL da requisição (relativo ou absoluto)
 * @param options - Opções do fetch (method, body, headers, etc.)
 * @returns Promise<Response>
 */
export const authenticatedFetch = async (
  url: string,
  options: RequestInit = {}
): Promise<Response> => {
  const token = localStorage.getItem('auth_token');
  const isFormData = options.body instanceof FormData;

  const headers: HeadersInit = {
    // Não definir Content-Type para FormData (browser define automaticamente com boundary)
    ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
    ...options.headers,
  };

  if (token) {
    (headers as Record<string, string>).Authorization = `Bearer ${token}`;
  }

  const fullUrl = url.startsWith('http') ? url : `${API_BASE_URL}${url}`;

  return fetch(fullUrl, {
    ...options,
    headers,
  });
};

